import { useCallback } from "react";
import axios from "../api/axios";

const API_BASE = "/sales/report";

// Common fetcher with filters
export const useSalesReports = () => {
  const fetchSummary = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/summary`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchTrend = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/trend`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchBranchGradeBreakdown = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/branch-grade-breakdown`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchBranchWise = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/branch-wise`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchGradeWise = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/grade-wise`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchPaymentModeSummary = (filters) =>
    axios
      .get(`${API_BASE}/payment-mode-summary`, { params: filters })
      .then((res) => res.data);

  const fetchVoucherSummary = (filters) =>
    axios
      .get(`${API_BASE}/voucher-summary`, { params: filters })
      .then((res) => res.data);

  return {
    fetchSummary,
    fetchTrend,
    fetchBranchGradeBreakdown,
    fetchBranchWise,
    fetchGradeWise,
    fetchPaymentModeSummary,
    fetchVoucherSummary,
  };
};
